import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  row: {
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f9f9f9',
    boxShadow: 'inset 0 -2px 0 #00a78f'
  },
  // background:
  headName: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    width: '60%',
    fontWeight: 'bold',
    color: '#4B4952',
    textAlign: 'start',
    position: 'sticky',
    fontSize: 14.5,
    top: 0,
    zIndex: 2,
    paddingLeft: 10
  },
  headValue: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    width: '30%',
    fontSize: 14.5,
    fontWeight: 'bold',
    color: '#4B4952',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    '@media all and (max-width: 1200px)': {
      display: 'none'
    }
  },
  headKebab: {
    width: '10%'
  }
}))

export default useStyles
